import { ModalService } from '../../services/model_service/model.service';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DataCommunicationService } from '../../services/data_service/data-communication.service';
import { ToastrService } from 'ngx-toastr';
import { DealerLocationComponent } from '../dealer-location/dealer-location.component';
import { LoaderindicatorService } from '../../services/loaderindicator/loaderindicator.service';
import { CommonService } from '../../services/common_services/common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'mgfw-dealer-detail',
  templateUrl: './dealer-detail.component.html',
  styleUrls: ['./dealer-detail.component.css']
})
export class DealerDetailComponent implements OnInit {

  @Input() dealerNumber: any;
  @Input() nextAvailableDate: boolean;
  @Input() selectAnotherDealer: boolean;
  showSelectAnotherDealer: false;

  @ViewChild(DealerLocationComponent) dealerLocationComponent;
  dealerDetails: any;
  holidaysList: any;
  workingDayList: any;
  workingDays: any;
  holidays='';
  shilftTiming: any;
  dealerID

  constructor(
    private readonly dataCommunicationService: DataCommunicationService,
    private modalService: ModalService,
    private loaderservice: LoaderindicatorService,
    private commonService: CommonService,
    private translate: TranslateService

  ) { }

  ngOnInit() {
    this.dealerID=this.commonService.getLocalStorage('dealername')
    this.translate.get('LoaderText.loading').subscribe(message => {
      this.loaderservice.show(message);
    });
    setTimeout(() => {
      this.loaderservice.hide();
    }, 5000);
    this.getDealerDetailsbyId(this.dealerNumber);
  }

  public getDealerDetailsbyId(dealerNumber: string): void {
    this.dataCommunicationService.getDealerById(dealerNumber).subscribe(result => {
      if (result.StatusCode === 1) {
        //console.log(result)
        this.holidaysList = [];
        this.workingDayList = [];
        this.dealerDetails = result.Data;
        this.dealerShiftTime();
      } else {
        this.commonService.getErrorMessage('LoaderText.NoDataFound');
      }
    });
  }

  public openDealerLocation(id: string, modeData: any) {
    this.modalService.open(id);
    this.dealerLocationComponent.getModType(modeData);
  }

  public dealerShiftTime() {
    this.workingDay();
    this.findholiday();
   
    this.translate.get('monthNames.days').subscribe(message => {
      this.workingDays = message[this.workingDayList[0] - 1] + ' - ' + message[this.workingDayList[this.workingDayList.length - 2]];
    });
    this.shilftTiming=this.dealerDetails.DealerShift.StartTime.split(':')[0]+':'+this.dealerDetails.DealerShift.StartTime.split(':')[1]
                    +' - '+this.dealerDetails.DealerShift.EndTime.split(':')[0]+':'+this.dealerDetails.DealerShift.EndTime.split(':')[1]

  }

  public workingDay() {
    if (this.dealerDetails.DealerShift.Days.find(x => x === 'Monday')) {
      this.workingDayList.push(1);
    }
    if (this.dealerDetails.DealerShift.Days.find(x => x === 'Tuesday')) {
      this.workingDayList.push(2);
    }
    if (this.dealerDetails.DealerShift.Days.find(x => x === 'Wednesday')) {
      this.workingDayList.push(3);
    }
    if (this.dealerDetails.DealerShift.Days.find(x => x === 'Thursday')) {
      this.workingDayList.push(4);
    }
    if (this.dealerDetails.DealerShift.Days.find(x => x === 'Friday')) {
      this.workingDayList.push(5);
    }
    if (this.dealerDetails.DealerShift.Days.find(x => x === 'Saturday')) {
      this.workingDayList.push(6);
    }
  }

  public findholiday() {
   
    if (!this.dealerDetails.DealerShift.Days.find(x => x === 'Monday')) {
      this.translate.get('monthNames.days').subscribe(message => {
        this.holidays = message[0] + ' - ';
      });
    }
    if (!this.dealerDetails.DealerShift.Days.find(x => x === 'Tuesday')) {
      this.translate.get('monthNames.days').subscribe(message => {
        this.holidays = this.holidays + message[1] + ' - ';
      });
    }
    if (!this.dealerDetails.DealerShift.Days.find(x => x === 'Wednesday')) {
      this.translate.get('monthNames.days').subscribe(message => {
        this.holidays = this.holidays + message[2] + ' - ';
      });
    }
    if (!this.dealerDetails.DealerShift.Days.find(x => x === 'Thursday')) {
      this.translate.get('monthNames.days').subscribe(message => {
        this.holidays = this.holidays + message[3] + ' - ';
      });
    }
    if (!this.dealerDetails.DealerShift.Days.find(x => x === 'Friday')) {
      this.translate.get('monthNames.days').subscribe(message => {
        this.holidays = this.holidays + message[4] + ' - ';
      });
    }
    if (!this.dealerDetails.DealerShift.Days.find(x => x === 'Saturday')) {
      this.translate.get('monthNames.days').subscribe(message => {
        this.holidays =this.holidays+ message[5] ;
      });
    }
  }
}
